import ApplicationController from "./application_controller";

//import TomSelect from 'tom-select/dist/esm/tom-select'
import TomSelect from 'tom-select'
import 'tom-select/dist/esm/plugins/remove_button/plugin'
import 'tom-select/dist/esm/plugins/dropdown_input/plugin'
import 'tom-select/dist/css/tom-select.css'
import '../stylesheets/tom-select.scss'

//const selectInput = document.getElementById('applicant_tag_list')

export default class extends ApplicationController {
    static targets = [ "input" ]

    connect() {
        this.initializeTomSelect();
    }

    disconnect() {
        this.destroyTomSelect();
    }

    validate() {
        const input = this.inputTarget;
        if (input.required && !input.value) {
            input.setCustomValidity('Dieses Feld ist erforderlich');
        } else {
            input.setCustomValidity('');
        }
    }

    initializeTomSelect() {
        // Return early if no element is associated with the controller.
        if (!this.element) return;
        
        // Check if inputTarget exists
        if (!this.hasInputTarget) {
            console.warn('TomSelect controller connected but no input target found', this.element)
            return;
        }

        const allowCreate = this.inputTarget.dataset.tomselectCreate === 'true';
        const isRequired = this.inputTarget.required;

        // Fetch options from the select element (inkl. data-data JSON für Logos etc.)
        const options = Array.from(this.inputTarget.options).map(option => {
            let extra = {};
            if (option.dataset.data) {
                try { extra = JSON.parse(option.dataset.data); } catch(e) {}
            }
            return {
                value: option.value,
                text: option.text,
                subtext: option.dataset.subtext,
                ...extra
            };
        });

        let plugins = {};
        const isMultiple = this.inputTarget.multiple;
        if (allowCreate || isMultiple) {
            plugins.remove_button = {
                title: 'Entfernen'
            };
        }

        let placeholder = this.inputTarget.dataset.placeholder ? this.inputTarget.dataset.placeholder : "Bitte auswählen";

        this.tomselect = new TomSelect(this.inputTarget, {
            plugins: plugins,
            persist: false,
            allowEmptyOption: !isRequired,
            create: allowCreate,
            // Getippten Wert beim Verlassen des Feldes übernehmen — sonst geht eine frei
            // eingegebene Adresse (z.B. CC) verloren, wenn direkt „Senden" geklickt wird,
            // ohne vorher Enter/Komma zu drücken (Ursache „CC funktioniert stichprobenartig").
            createOnBlur: allowCreate,
            dropdownParent: 'body',
            placeholder: placeholder,
            options: options,
            openOnFocus: true,
            preload: 'focus',
            closeAfterSelect: true,
            selectOnTab: true,
            maxOptions: 100,
            render: {
                no_results: function (data, escape) {
                    return '<div class="no-results">Keine Ergebnisse für "' + escape(data.input) + '". Entfernen mit der ␛-Taste</div>';
                },
                option_create: function(data, escape) {
                    if (allowCreate) {
                        return '<div class="create"><strong>' + escape(data.input) + '</strong> hinzufügen &hellip;</div>';
                    } else {
                        return '';
                    }
                },
                option: function(data, escape) {
                    const title = (data.text || '').trim();
                    const subtextValue = (data.subtext || '').trim();
                    const subtext = subtextValue.length > 0
                        ? '<span class="subtext text-xs text-gray-400 truncate">' + escape(subtextValue) + '</span>'
                        : '';
                    const logoHtml = data.logoHtml || '';
                    return '<div class="option-content flex items-center gap-2">' +
                        logoHtml +
                        '<span class="title text-sm leading-tight">' + escape(title) + '</span>' +
                        subtext +
                        '</div>';
                },
                item: function(data, escape) {
                    const logoHtml = data.logoHtml || '';
                    return '<div class="item text-sm flex items-center gap-1">' + logoHtml + '<span>' + escape((data.text || '').trim()) + '</span></div>';
                },
                render: {
                    loading_more: function(data, escape) {
                        return `<div class="loading-more-results py-2 d-flex align-items-center"><div class="spinner"></div> Wird geladen</div>`;
                    }
                },
            },
            onInitialize: () => {
                this.inputTarget.classList.remove('hidden');
            },
            onChange: () => {
                this.validate();
            }
        });
    }

    destroyTomSelect() {
        this.tomselect.destroy(this.inputTarget)
    }
}
